//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.section`
    width: ${({ width = "unset" }) => width};
    height: max-content;
    overflow-y: scroll;
    max-height: ${({ maxHeight = "350px" }) => maxHeight};
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
`;
export const Table = styled.table`
    width: ${({ width = "100vw" }) => width};
    min-width: ${({ minWidth = "300px" }) => minWidth};
    max-width: ${({ maxWidth = "350px" }) => maxWidth};
    border-collapse: collapse;
    & tbody td {
        & svg {
            height: 20px;
        }
    }
`;
export const HeaderCell = styled.div`
    display: flex;
    justify-content: ${({ justify = "center" }) => justify};
    align-items: center;
    gap: 5px;
    margin-bottom: 10px;
    padding: ${({ padding = "unset" }) => padding};
    min-width: ${({ minWidth = "unset" }) => minWidth};
    & span {
        color: var(--dark-4);
        font-size: 14px;
        width: ${({ width = "unset" }) => width};
    }
`;
export const THead = styled.thead`
    position: sticky;
    top: 0;
    background-color: var(--light-1);
    z-index: 10;
`;
export const TFoot = styled.tfoot`
    position: sticky;
    bottom: 0;
    background-color: var(--light-1);
    z-index: 10;
`;